import React, { useState } from 'react';
import ParallaxImage from '../home/ParallaxImage';
import GreenButton from '../home/GreenButton';
import ShowroomModal from '../home/ShowroomModal';

/** Showroom band: 4000 styles / 100 brands and 200+ garments on display. */
const ShopShowroomBand: React.FC = () => {
  const [showroomOpen, setShowroomOpen] = useState(false);

  return (
    <>
      <ParallaxImage
        src="/home/showroom.jpg"
        overlay="rgba(0,0,0,0.5)"
        className="min-h-[480px] md:min-h-[600px] flex items-center justify-center text-white px-6"
      >
        <div className="text-center max-w-4xl mx-auto py-20">
          <h2 className="font-montserrat font-extrabold tracking-[-0.03em] leading-[1.08] text-[clamp(28px,4vw,56px)]">
            Over 4000 styles from 100 brands to choose from.
            <br className="hidden sm:inline" />
            {' '}With 200+ garments on display in our Kidderminster Showroom!
          </h2>
          <img
            src="/home/scribble-green.png"
            alt=""
            aria-hidden="true"
            className="mx-auto mt-5 w-40 md:w-56 h-auto"
            loading="lazy"
          />
          <div className="mt-8">
            <GreenButton onClick={() => setShowroomOpen(true)}>Visit our showroom</GreenButton>
          </div>
        </div>
      </ParallaxImage>
      <ShowroomModal isOpen={showroomOpen} onClose={() => setShowroomOpen(false)} />
    </>
  );
};

export default ShopShowroomBand;
